<style lang="scss">
  @import '../resources/scss/donation_contact_btn.scss'; ;
</style>

<script lang="ts">
  import { locale } from 'svelte-i18n'
  import { getDonationButtonData } from '../controllers/DonationsController'
  import { donation } from '../stores/stores'
  import ArrowRight from './svgs/ArrowRight.svelte'
  import Letter from './svgs/Letter.svelte'

  let lang = $locale!

  getDonationButtonData(lang)
</script>

{#if Object.keys($donation).length != 0}
  <div class="container-xxl text-primary-green h4 mb-0 py-section">
    <div class="mb-4 pb-3">
      {@html $donation.text}
    </div>
    <a
      href="mailto:{$donation.email}"
      class="donation-button d-flex align-items-center bg_primary_f p-4 rounded-lg"
    >
      <span class="green pe-3"><Letter /></span>
      <span class="h4 send-email mb-0">{$donation.email}</span>
      <span class="green ms-auto"><ArrowRight /></span>
    </a>
  </div>
{/if}
